import IsIos from '@/mixins/is-ios.js'
import IsStandalone from '@/mixins/is-standalone.js'
import CurrentUserResolver from '@/mixins/current-user-resolver.js'
import lockersStore from '@/stores/lockers-store.js'
import baseStore from '@/stores/Store.js'
import axios from 'axios'
import { EventBus } from '@/event-bus.js'

export default {
  name: 'NavRoot',
  mixins: [IsIos, IsStandalone, CurrentUserResolver],
  data: function () {
    return {
      trigger: false,
      showLockerTab: false,
    }
  },
  computed: {
    isDotDisplayed() {
      return this.currentUser
        ? !(this.currentUser.phoneIsVerified && !!this.currentUser.name)
        : null
    },
    hasAnyMembersInSpContainingSelfAssignedCps() {
      return (this.currentUser || {}).hasAnyMembersInSpContainingSelfAssignedCps
    },
  },
  created() {
    EventBus.$on('prefetchLockers', this.prefetchLockers)
  },
  mounted() {
    baseStore.subscribe((mutation, state) => {
      if (mutation.type == 'memoLastPage') {
        this.trigger = !this.trigger
      }
    })
    this.prefetchLockers()
  },
  methods: {
    getLastPage(base, trigger) {
      return baseStore.getters.lastPageFor(base)
    },
    prefetchLockers() {
      if (this.currentUser) {
        this.blocker = true
        axios({
          method: 'get',
          url: 'boxes',
          params: {
            page: 0,
            page_size: 1,
          },
        })
          .then(response => {
            this.blocker = false
            lockersStore.commit('fetchLockers', response.data)
            response.data.length ? (this.showLockerTab = true) : false
            console.log('prefetchLockers response', response)
          })
          .catch(error => {
            this.blocker = false
            console.error('prefetchLockers error', error.response)
          })
      }
    },
  },
}
